/* GingerMood case validation. Every composed case must contain exactly 12 bottles. */
(function () {
  var CASE_SIZE = 12;
  var origFetch = window.fetch;

  function money(cents, fr) {
    return new Intl.NumberFormat(fr ? 'fr-CA' : 'en-CA', {
      style: 'currency',
      currency: 'CAD'
    }).format(cents / 100);
  }

  function migrateCaseProperties(cart) {
    var fr = document.documentElement.lang.toLowerCase().indexOf('fr') === 0;
    var label = fr ? 'Prix unitaire' : 'Unit price';
    var oldLabel = fr ? 'Unit price' : 'Prix unitaire';
    var lines = cart.items.filter(function (item) {
      var properties = item.properties || {};
      return properties._gm_case_id && (properties.Caisse || properties[oldLabel] || !properties[label]);
    });

    return lines.reduce(function (request, item) {
      return request.then(function () {
        var properties = Object.assign({}, item.properties || {});
        delete properties.Caisse;
        delete properties['Prix unitaire'];
        delete properties['Unit price'];
        properties[label] = money(item.final_price, fr);
        return origFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: properties })
        }).then(function (response) {
          if (!response.ok) throw new Error('case-property-migration-failed');
        });
      });
    }, Promise.resolve()).then(function () { return lines.length > 0; });
  }

  function checkCart(cart) {
    var cases = {};
    var legacyCounts = { '250': 0, '750': 0 };
    cart.items.forEach(function (item) {
      if (item.product_type !== 'Élixir de santé') return;
      var properties = item.properties || {};
      var formatMatch = String(properties._gm_case_format || item.variant_title || '').match(/(250|750)/);
      var format = formatMatch ? formatMatch[1] : '';
      var caseId = properties._gm_case_id;
      if (caseId) {
        if (!cases[caseId]) cases[caseId] = { format: format, quantity: 0 };
        cases[caseId].quantity += item.quantity;
      } else if (legacyCounts[format] !== undefined) {
        legacyCounts[format] += item.quantity;
      }
    });

    var invalid = [];
    Object.keys(cases).forEach(function (caseId) {
      if (cases[caseId].quantity !== CASE_SIZE) invalid.push(cases[caseId]);
    });
    Object.keys(legacyCounts).forEach(function (format) {
      if (legacyCounts[format] > 0 && legacyCounts[format] % CASE_SIZE !== 0) {
        invalid.push({ format: format, quantity: legacyCounts[format], legacy: true });
      }
    });
    return invalid;
  }

  function render(invalid, cartIsEmpty) {
    var buttons = document.querySelectorAll('#checkout, #CartDrawer-Checkout');
    var fr = document.documentElement.lang.toLowerCase().indexOf('fr') === 0;
    var msg = invalid.map(function (entry) {
      if (fr) {
        return entry.legacy
          ? 'Les élixirs de ' + entry.format + ' ml doivent former des caisses complètes de 12 bouteilles.'
          : 'La caisse de ' + entry.format + ' ml contient ' + entry.quantity + ' bouteilles au lieu de 12.';
      }
      return entry.legacy
        ? entry.format + ' ml elixirs must form complete cases of 12 bottles.'
        : 'The ' + entry.format + ' ml case contains ' + entry.quantity + ' bottles instead of 12.';
    }).join(' ');

    document.querySelectorAll('.gm-cart-min-msg').forEach(function (el) { el.remove(); });

    buttons.forEach(function (btn) {
      if (invalid.length > 0) {
        btn.disabled = true;
        btn.dataset.gmCartBlocked = 'true';
        btn.setAttribute('aria-disabled', 'true');
        var note = document.createElement('p');
        note.className = 'gm-cart-min-msg';
        note.setAttribute('role', 'alert');
        note.textContent = msg;
        var ctas = btn.closest('.cart__ctas');
        if (ctas && ctas.parentNode) ctas.parentNode.insertBefore(note, ctas);
      } else if (btn.dataset.gmCartBlocked) {
        delete btn.dataset.gmCartBlocked;
        btn.removeAttribute('aria-disabled');
        if (!cartIsEmpty) btn.disabled = false;
      }
    });

    document.querySelectorAll('.additional-checkout-buttons').forEach(function (container) {
      container.hidden = invalid.length > 0;
    });
  }

  function refresh() {
    origFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return migrateCaseProperties(cart).then(function (migrated) {
          if (!migrated) return cart;
          return origFetch('/cart.js').then(function (response) { return response.json(); });
        });
      })
      .then(function (cart) { render(checkCart(cart), cart.item_count === 0); })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', refresh);
  window.setTimeout(refresh, 1200);
  // re-vérifier après chaque appel AJAX au panier (ajout, retrait, quantité)
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var p = origFetch.apply(this, arguments);
    if (url.indexOf('/cart') !== -1 && url.indexOf('/cart.js') === -1) {
      p.then(function () { setTimeout(refresh, 250); });
    }
    return p;
  };
})();
